import { useQuery } from "@tanstack/react-query"
import { classes } from "@shared/api/services";

export const useOrder = (id) => {
    return useQuery({
        queryKey: ['order', id],
        queryFn: () => classes.getOrderById(id),
        select: (data) => data.data?.json || data.data,
				enabled: !!id
    });
};